import axiosClient from "./axiosClient";

export interface LogEntry {
  id: number;
  id_origin: number;
  id_reference: number | null;
  operation: string;
  description: string | null;
  user_id: number | null;
  user_name?: string | null;
  created_at: string;
  updated_at: string;
}

export interface LogsResponse {
  status: string;
  count: number;
  logs: LogEntry[];
}

/**
 * Fetch logs for a specific PTO request
 */
export async function fetchLogsForPTORequest(
  ptoRequestId: number
): Promise<LogEntry[]> {
  try {
    const response = await axiosClient.get<LogsResponse>(
      `/logs_api/logs?reference=${ptoRequestId}`
    );
    return response.data.logs;
  } catch (error) {
    console.error("Failed to fetch logs for PTO request:", error);
    throw error;
  }
}

/**
 * Fetch all logs with optional filters
 */
export async function fetchLogs(params?: {
  origin?: number;
  reference?: number;
  user?: number;
  operation?: string;
  limit?: number;
  offset?: number;
}): Promise<LogsResponse> {
  try {
    const queryParams = new URLSearchParams();
    if (params?.origin) queryParams.append("origin", params.origin.toString());
    if (params?.reference)
      queryParams.append("reference", params.reference.toString());
    if (params?.user) queryParams.append("user", params.user.toString());
    if (params?.operation) queryParams.append("operation", params.operation);
    if (params?.limit) queryParams.append("limit", params.limit.toString());
    if (params?.offset) queryParams.append("offset", params.offset.toString());

    const response = await axiosClient.get<LogsResponse>(
      `/logs_api/logs?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch logs:", error);
    throw error;
  }
}

/**
 * Version history entry from SQLAlchemy-Continuum
 */
export interface VersionHistoryEntry {
  transaction_id: number;
  timestamp: string | null;
  operation: string;
  status: string | null;
  status_reason: string | null;
  description: string | null;
  start_date: string | null;
  end_date: string | null;
  hours_requested: number | null;
  pto_balance_at_request: number | null;
  pto_balance_after: number | null;
  user_id: number | null;
  user_type: string | null;
  name: string | null;
}

export interface VersionHistoryResponse {
  pto_request_id: number;
  history: VersionHistoryEntry[];
}

/**
 * Fetch version history for a specific PTO request from SQLAlchemy-Continuum
 */
export async function fetchPTOVersionHistory(
  ptoRequestId: number
): Promise<VersionHistoryEntry[]> {
  try {
    const response = await axiosClient.get<VersionHistoryResponse>(
      `/pto_api/history/${ptoRequestId}`
    );
    return response.data.history;
  } catch (error) {
    console.error("Failed to fetch PTO version history:", error);
    throw error;
  }
}
